import { Directive } from '@angular/core';
import { ImmomioIconName, WhitelabelImage, WhitelabelImageType } from '../../models';
import { getResendVerifyEmailActionState } from '../../+state';
import { Store } from '@ngrx/store';
import { IActionState } from '../../utils';
import { Observable } from 'rxjs';

@Directive()
export abstract class UnverifiedUserBaseComponent {
  public imagePath = '~/assets/shared/images/email-sent.png';
  public whitelabelImage = WhitelabelImage;
  public whitelabelImageType = WhitelabelImageType;
  public immomioIconName = ImmomioIconName;
  public resendTriggered = false;
  public resendVerifyEmailActionState$: Observable<IActionState>;

  constructor(store: Store) {
    this.resendVerifyEmailActionState$ = store.select(getResendVerifyEmailActionState);
  }

  abstract backToLogin(): void;
}
